
import { File, Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { CardHeader, CardTitle } from "@/components/ui/card";
import { CreateSection } from "./CreateSection";
import { useState } from "react";
import { useLanguage } from "@/contexts/LanguageContext";

interface Section {
  id: string;
  name: string;
  position: number;
  section_type: 'DOCUMENTS' | 'FAQ';
}

interface DocumentsPageHeaderProps {
  onSectionCreated: (section: Section) => void;
  organizationId: string;
}

export const DocumentsPageHeader = ({ onSectionCreated, organizationId }: DocumentsPageHeaderProps) => {
  const { t } = useLanguage();
  const [showCreateForm, setShowCreateForm] = useState(false);

  return (
    <CardHeader>
      <CardTitle className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4">
        <div className="flex items-center gap-2">
          <File className="h-5 w-5" />
          {t('nav.documents')}
        </div>
        <Button 
          onClick={() => setShowCreateForm(!showCreateForm)}
          className="w-full sm:w-auto flex items-center gap-2"
        >
          <Plus className="h-4 w-4" />
          {showCreateForm ? t('documents.cancel') : t('documents.add_section')}
        </Button>
      </CardTitle>
      {showCreateForm && (
        <CreateSection 
          onSectionCreated={(section: Section) => {
            onSectionCreated(section);
            setShowCreateForm(false);
          }}
          organizationId={organizationId}
        />
      )}
    </CardHeader>
  );
};
